import React from 'react'
import {Flex, Box} from "@chakra-ui/react";

function AdGirl() {
  return (
    <Box className="login_pic">
     <img
   
          className="login_women"
          src="https://blog-cdn.everhour.com/assets/images/new-design/illustrations/primary-illustrations/footer.jpg"
        />
      </Box>
  )
}

export default AdGirl
